import { useNode } from '@craftjs/core';
import { useFormContext, Controller } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { FormFileInputComponent } from 'src/features/generalForms/builder/types/FileInput';
import { AppAttachmentsField } from 'src/features/generalForms/uikit/fields/attachmentsField/attachmentsField.component';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';
import { validateFileRule } from 'uikit/appAttachmentsV2/Hook-form-helpers';

export const FormFileInput: FormFileInputComponent = (props) => {
  const {
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);

  if (!visible) {
    return <></>;
  }

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={{ ...styles, boxSizing: 'border-box' }}>
      <Controller
        control={form.control}
        name={props.dataKey!}
        rules={{
          ...hookFormRules({ required: !props.isOptional && !isDisabled }),
          validate: validateFileRule(props.fileTypes, props.maxFileSizeMb),
        }}
        render={({ field: { value, onChange }, formState: { isSubmitting } }) => (
          <AppAttachmentsField
            addFileButtonText={props.addFileButtonText ?? ''}
            labelProps={{
              text: props.title,
              isBold: true,
              tooltip: props.tooltip,
              description: props.description,
              isOptional: props.isOptional,
              prefix: props.prefix,
            }}
            disabled={isDisabled || isSubmitting}
            multiple={props.isMultiple}
            errorProps={{ errors }}
            value={value}
            onChange={onChange}
            fileTypes={props.fileTypes}
            maxFileSizeMb={props.maxFileSizeMb}
          />
        )}
      />
    </div>
  );
};
